import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Funciona si tengo restricciones alimentarias?',
  a: 'Sí. El libro incluye una tabla completa de sustituciones para versiones sin gluten, veganas y sin lactosa de cada receta. Está diseñado para ser inclusivo.'
}, {
  q: '¿Necesito cocinar mucho o tener experiencia?',
  a: 'No. La mayoría de recetas tienen 3 a 5 pasos simples. Si puedes cortar un aguacate y abrir una lata, puedes hacer el 80% de estas recetas.'
}, {
  q: '¿Los ingredientes son caros o difíciles de conseguir?',
  a: 'No. Todos los ingredientes se consiguen en Walmart, Target o cualquier supermercado latino. La mayoría cuesta menos de $2 por porción.'
}, {
  q: '¿Funciona aunque yo no esté haciendo ninguna dieta?',
  a: 'Absolutamente. Snack Sin Antojo no es un complemento de una dieta. Es un sistema independiente. Funciona sola o combinado con cualquier plan de alimentación.'
}, {
  q: '¿Cómo recibo el ebook después de comprar?',
  a: 'Acceso inmediato. En cuanto se procesa tu pago, recibes un email con el enlace de descarga. En menos de 2 minutos tienes el libro en tu dispositivo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-brand-cream text-brand-darkText" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark" data-id="element-46">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-brand-light/20 overflow-hidden shadow-sm" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-49">
                <span className="font-bold text-brand-dark pr-4" data-id="element-50">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-medium transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>

              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-53">
                    <div className="p-6 pt-0 text-brand-dark/70 leading-relaxed border-t border-brand-light/10" data-id="element-54">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}